import React, { Component } from "react"
import {
  CLOUDINARY_NAME,
  CLOUDINARY_DOCUMENTS_PRESET,
  CLOUDINARY_API_KEY
} from "../../../constants/images/cloudinary"
import "./cardTrigger.css"
import { apiProcess } from "../../api/api.js"
import { Columns } from 'components/elements'

class LicenseCardInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      generalError: false,
      licenseBack: this.props.licenseBack,
      licenseFront: this.props.licenseFront,
      licenseBackID: this.props.licenseBack,
      licenseFrontID: this.props.licenseFront,
      licenseBackThumbnail: this.props.licenseBackThumbnail,
      licenseFrontThumbnail: this.props.licenseFrontThumbnail,
      licenseError: false,
      targetSide: null
    }
    this.cloudWidget = window.cloudinary.createUploadWidget(
      {
        cloudName: CLOUDINARY_NAME,
        apiKey: CLOUDINARY_API_KEY,
        uploadSignature: this.makeCloudinarySignature,
        uploadPreset: CLOUDINARY_DOCUMENTS_PRESET,
        sources: ["local"],
        showAdvancedOptions: false,
        //cropping: true,
        //croppingShowBackButton : false,
        //croppingAspectRatio : 1.65,
        //croppingDefaultSelectionRatio :  .85,
        multiple: false,
        defaultSource: "local",

        styles: {
          palette: {
            window: "#ffffff",
            sourceBg: "#f4f4f5",
            windowBorder: "#90a0b3",
            tabIcon: "#000000",
            inactiveTabIcon: "#555a5f",
            menuIcons: "#555a5f",
            link: "#B9995A",
            action: "#339933",
            inProgress: "#0433ff",
            complete: "#339933",
            error: "#cc0000",
            textDark: "#000000",
            textLight: "#fcfffd"
          },
          fonts: {
            default: null,
            "sans-serif": {
              url: null,
              active: true
            }
          }
        }
      },
      (err, result) => {
        if (!err) {
          if (result.event === "success") {
            if (this.state.targetSide === "front") {
              this.setState({ licenseFront: result.info.secure_url })
              this.setState({ licenseFrontID: result.info.public_id })
              this.setState({ licenseFrontThumbnail: result.info.secure_url }) //we reuse imageURL here on update because thumbnail doesn't come back secure. w/e.
              this.props.onChange(
                "front",
                result.info.secure_url,
                result.info.public_id
              )
            } else {
              this.setState({ licenseBack: result.info.secure_url })
              this.setState({ licenseBackID: result.info.public_id })
              this.setState({ licenseBackThumbnail: result.info.secure_url }) //we reuse imageURL here on update because thumbnail doesn't come back secure. w/e.
              this.props.onChange(
                "back",
                result.info.secure_url,
                result.info.public_id
              )
            }
          }
        } else {
          this.setState({
            generalError:
              "Sorry, we are having upload issues right now. Please try again."
          })
        }
      }
    )
  }

  changeLicense = side => {
    this.setState({ targetSide: side })
    this.cloudWidget.open()
  }

  makeCloudinarySignature = (callBack, paramsToSign) => {
    let apiURL = "media/images/secure_upload_token"

    let sigData = {
      params_to_sign: paramsToSign
    }

    apiProcess(
      apiURL,
      sigData,
      "cloudinary-signature",
      "Generate Cloudinary Upload Sig from License Field"
    )
      .then(function(responseData) {
        callBack(responseData.cloudinary_signed_token)
      })
      .catch(function(responseData) {
        //alert('THIS IS NOT WORKING FUCCKKKKKK')
      })
  }

  render() {
    const {
      generalError,
      licenseBackThumbnail,
      licenseFrontThumbnail
    } = this.state

    const { error } = this.props
    return (
      <React.Fragment>
        {this.props.showSubDescription && (
          <p className="has-text-centered has-text-weight-bold mb-3">
            Upload photos of your driver's license.
          </p>
        )}
        {generalError && <div>{generalError}</div>}
        <Columns className="is-vcentered is-mobile">
          <Columns.Column size={6}>
            <button
              className="card-trigger-wrap"
              onClick={() => this.changeLicense("front")}
            >
              {licenseFrontThumbnail == null && (
                <div className="card-trigger-inside">
                  Front of Card
                  <br />
                  <span>+</span>
                </div>
              )}
              {licenseFrontThumbnail !== null && (
                <React.Fragment>
                  <img src={licenseFrontThumbnail} alt="License Card - Front" />
                  <p className="field-sub-description">
                    <i className="fal fa-pencil-alt"></i>
                  </p>
                </React.Fragment>
              )}
            </button>
          </Columns.Column>
          <Columns.Column size={6}>
            <button
              className="card-trigger-wrap"
              onClick={() => this.changeLicense("back")}
            >
              {licenseBackThumbnail == null && (
                <div className="card-trigger-inside">
                  Back of Card
                  <br />
                  <span>+</span>
                </div>
              )}
              {licenseBackThumbnail !== null && (
                <React.Fragment>
                  <img src={licenseBackThumbnail} alt="License Card - Back" />
                  <p className="field-sub-description">
                    <i className="fal fa-pencil-alt"></i>
                  </p>
                </React.Fragment>
              )}
            </button>
          </Columns.Column>
        </Columns>
        {error && (
          <div className="has-text-danger is-size-7">
            You must upload front AND back images of your driver's license.
          </div>
        )}
      </React.Fragment>
    )
  }
}
export default LicenseCardInput

LicenseCardInput.defaultProps = {
  licenseBack: null,
  licenseFront: null,
  licenseBackID: null,
  licenseFrontID: null,
  licenseBackThumbnail: null,
  licenseFrontThumbnail: null,
  error: false,
  showSubDescription: true,
  onChange: null
}
